import React from 'react';

const OneNoteRow = ({item, toggleChkBox}) => {
    return (
      <li>
        <img className="onenote-img" src={`${wbConfig.baseUrl}/images/meetings/onenote.png`} width="15px" />
        <span className="onenote-book-name">{item.name}</span>
        <ul>
          {item.sections.map((val, index) => (
            <li className="selected-one-note-item-li" data-id={val.id} key={index}>
              <span>
                <input onChange={e => toggleChkBox(e, val)} type="radio" name="notebook" id={val.id} />
                <span className="onenote-item-label">{val.name}</span>
              </span>
            </li>
          ))}
        </ul>
      </li>
    );
};

export default OneNoteRow;